import React from "react";

import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import angular from "../assets/Angular.png";
import node from "../assets/node.png";
//import graphql from "../assets/graphql.png";
import github from "../assets/github.png";
//import tailwind from "../assets/tailwind.png";
import java from "../assets/java.png";
import C from "../assets/c.png";
import bootstrap from "../assets/bootstrap.png";
import react from "../assets/react.png";
//import mongodb from "../assets/mngodb.jpeg"

const Skills = () => {
  const techs = [
    {
      id: 1,
      src: html,
      title: "HTML",
      style: "shadow-orange-500",
    },
    {
      id: 2,
      src: css,
      title: "CSS",
      style: "shadow-blue-500",
    },
    {
      id: 3,
      src: javascript,
      title: "JavaScript",
      style: "shadow-yellow-500",
    },
    {
      id: 4,
      src: java,
      title: "Java",
      style: "shadow-gray-400",
    },
    {
      id: 5,
      src: angular,
      title: "Angular",
      style: "shadow-red-700",
    },
    {
      id: 6,
      src: C,
      title: "C",
      style: "shadow-blue-600",
    },
    {
      id: 7,
      src: bootstrap,
      title: "Bootstrap",
      style: "shadow-purple-600",
    },
    
    {
      id: 8,
       src: react,
      title: "React",
      style: "shadow-blue-400",
    },
    
    //{
      //id: 9,
      //src: express,
      //title: "Express JS",
      //style: "shadow-green-400",
    //},
    
    //{
      //id: 10,
      //src: mongodb,
      //title: "MongoDB",
      //style: "shadow-green-400",
    //;},
    {
      id: 11,
      src: github,
      title: "GitHub",
      style: "shadow-gray-400",
    },
  ];

  return (
    <div
      name="skills"
      className="bg-gradient-to-b from-gray-800 to-black w-full h-fit" 
      
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-fit text-white" >
        <div style={{marginTop:"100px"}}>
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
            Skills
          </p>
          <p className="py-6">These are the technologies I've worked with</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {techs.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}
            >
              <img src={src} alt="" className="w-20 mx-auto h-20" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
